module.exports = __webpack_public_path__ + "static/media/title_youtube.2e87e68a.png";